import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { authUserRequest, authUserSuccess, authUserFailure } from '../reducers/login';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/getAuthUser`;

function* authUserFunctionAxios() {
  const state = yield select(fullState => fullState);
  const { token } = state.loginReducer;

  return yield call(() =>
    axios({
      method: 'post',
      url: API,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      data: {
        token,
      },
    }),
  );
}

function* workerAuthUserSaga() {
  try {
    const response = yield call(authUserFunctionAxios);
    const responseFromLogin = response.data;

    if (response.status === 200) {
      yield put(authUserSuccess(responseFromLogin));
    }
    if (response.status === 401) {
      yield put(authUserFailure(response));
    }
    if (response.status === 500) {
      yield put(authUserFailure(response));
    }
  } catch (error) {
    yield put(authUserFailure(error.response));
  }
}

export function* watcherAuthUserSaga() {
  yield takeLatest(authUserRequest().type, workerAuthUserSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/post_auth.js